import {
  Container,
  ContainerPadding,
  Text,
  TextTag,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import TopBar from '../components/TopBar';
import {getTranslations} from '../translations';
import {ScreenreaderOnlyWrapper} from '../utils/styles';
import ResultsInit from './ResultsInit';

export default () => {
  const {labels} = getTranslations();

  return (
    <Container
      stretchContent
      wrap="always"
      padding={{bottom: ContainerPadding.grid001}}
    >
      <ScreenreaderOnlyWrapper>
        <Text tag={TextTag.h2}>{labels.results}</Text>
      </ScreenreaderOnlyWrapper>

      <TopBar />
      <ResultsInit />
    </Container>
  );
};
